import * as types from './actionTypes';
import { beginAjaxCall, ajaxCallError } from './ajaxStatusActions';
import axios from 'axios';
import { baseApi } from '../constants/app';

export function loadPayPeriodWeeksSuccess(payWeeks) {
  return { type: types.LOAD_PAY_PERIOD_WEEKS_SUCCESS, payWeeks };
}

export function createPayPeriodWeekSuccess(payWeek) {
  return { type: types.CREATE_PAY_PERIOD_WEEK_SUCCESS, payWeek };
}

export function updatePayPeriodWeekSuccess(payWeek) {
  return { type: types.UPDATE_PAY_PERIOD_WEEK_SUCCESS, payWeek };
}

export function deletePayPeriodWeekSuccess(payWeek) {
  return { type: types.DELETE_PAY_PERIOD_WEEK_SUCCESS, payWeek };
}

export function loadPayPeriodWeeks() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'pay-period-weeks';
    return axios
      .get(url)
      .then((response) => {
        dispatch(loadPayPeriodWeeksSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}

export function savePayWeek(payWeek) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let url = baseApi + 'pay-period-weeks';
    if (payWeek.id) {
      url = baseApi + 'pay-period-weeks/' + payWeek.id;
      return axios
        .put(url, {
          ...payWeek,
        })
        .then((response) => {
          dispatch(updatePayPeriodWeekSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    } else {
      return axios
        .post(url, {
          payPeriodId: payWeek.payPeriodId,
          startDate: payWeek.startDate,
          endDate: payWeek.startDate,
        })
        .then((response) => {
          dispatch(createPayPeriodWeekSuccess(response.data));
        })
        .catch((error) => {
          dispatch(ajaxCallError(error));
          throw error;
        });
    }
  };
}

export function deletePayWeek(payWeek) {
  return function (dispatch) {
    let url = baseApi + 'pay-period-weeks/' + payWeek.id;
    return axios
      .delete(url)
      .then((response) => {
        dispatch(deletePayPeriodWeekSuccess(response.data));
      })
      .catch((error) => {
        dispatch(ajaxCallError(error));
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/payWeekActions.js